import EmptyState from "components/EmptyState/EmptyState"

export const DisputeEvidenceEmptyState = () => {
    return (
        <div className="flex flex-col gap-4">
            <EmptyState
                title="Add Dispute Evidence"
                description="Upload or attach relevant files, screenshots, or logs to support your dispute and help us resolve the case faster."
                onClick={() => { }}
                icon="fa-regular fa-circle-plus"
                hideButton={true}
                className="border-none"
                maxHeight="350px"
            />
        </div>
    )
}